import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'


class NoMatch extends Component {

  componentDidMount(){
    window.document.title = "404 - Pattycake";
  }

  render(){
    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-background translucent">
          {/*<img src="/img/herring-bone.png" width="100%"/>*/}
        </div>
        <div className="shc-content">
          <Header transparent={true}/>
          
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-md-4">
                  <h1 className="brand-font text-center">
                    404 Error
                  </h1>
                  <p className="text-center">
                    We can't make anything with those ingredients, <nobr>try these instead:</nobr>
                  </p>
                  <div className="col-themed col-themed-shadow">
                    <ul className="bullet-list">
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 1/2 cup of butter</li>
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 3/4 cup of sugar</li>
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 1 cup of milk</li>
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 2 cups of flour</li>
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 2 eggs</li>
                      <li><span className="fa-li"><i className="fal fa-angle-right"></i></span> 1 tsp of vanilla extract</li>
                    </ul>
                    <hr/>
                    <ul className="bullet-list">
                      <li><span className="fa-li">1.</span> Preheat oven to 350°F</li>
                      <li><span className="fa-li">2.</span> Combine butter, sugar, vanilla, and eggs using a mixer</li>
                      <li><span className="fa-li">3.</span> Slowly add flour and milk, repeating until combined</li>
                      <li><span className="fa-li">4.</span> Pour into lined muffin tray</li>
                      <li><span className="fa-li">5.</span> Bake for 12-14 minutes</li>
                      <li className="no-margin-bottom"><span className="fa-li">6.</span> Cool before decorating</li>
                    </ul>
                  </div>

                  <div className="list-center">
                    <Link to="/" className="button-link list-item">
                      <Button 
                        display={<span>Launch Pattycake&nbsp;&nbsp;<i className="fad fa-angle-double-right"/></span>}
                        size="large" 
                        color="primary"
                        />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
      </div>
      <Footer/>
    </div>
  }
}

export default NoMatch
  


// WEBPACK FOOTER //
// ./src/routes/NoMatch.js